module.exports = __webpack_public_path__ + "img/approvedIcon.4d8017f6.svg";